import { render } from "./StoreOnboardingStepVerticals.vue?vue&type=template&id=5a5825db"
import script from "./StoreOnboardingStepVerticals.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepVerticals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__